import { Link } from "@tanstack/react-router";
import type { NieuwsArtikel } from "@/lib/nieuws-shared";
import { nieuwsDatumPill } from "@/lib/nieuws-shared";
export function nieuwsFoto(_dienst: string): string | undefined {
  // Restore only verified, matching owner-supplied photographs.
  return undefined;
}

type NieuwsVuller = { img?: string; datum: string; titel: string; tekst: string; lees: string; to: string };

function NieuwsKaart({
  img,
  imgAlt,
  datum,
  datumIso,
  titel,
  tekst,
  to,
  params,
  lees = "Lees artikel",
}: {
  img?: string | undefined;
  imgAlt: string;
  datum: string;
  datumIso?: string;
  titel: string;
  tekst: string;
  to: string;
  params?: { slug: string };
  lees?: string;
}) {
  const linkProps = params ? { to, params } : { to };
  return (
    <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-[#E0E0E0] bg-white">
      {img && <Link {...linkProps} className="shrink-0">
        <img src={img} alt={imgAlt} width={600} height={400} className="h-44 w-full object-cover" loading="lazy" />
      </Link>}
      <div className="flex flex-1 flex-col items-start p-5">
        <time dateTime={datumIso} className="inline-block rounded-full bg-[#E3EBF6] px-2.5 py-1 text-xs font-semibold uppercase text-[#2B63AB]">
          {datum}
        </time>
        <h3 className="mt-3 text-base font-bold leading-snug text-[#1A1A1A]">
          <Link {...linkProps}>{titel}</Link>
        </h3>
        <p className="mt-2 mb-3 line-clamp-3 text-sm text-[#555555]">{tekst}</p>
        <Link {...linkProps} className="mt-auto inline-block text-sm font-bold text-[#0056B3] hover:underline">
          {lees} →
        </Link>
      </div>
    </article>
  );
}

export function NieuwsKaarten({ artikelen, vullers }: { artikelen: NieuwsArtikel[]; vullers?: NieuwsVuller[] }) {
  return (
    <div className="mt-8 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {artikelen.map((a) => (
        <NieuwsKaart
          key={a.id}
          img={nieuwsFoto(a.dienst_slug)}
          imgAlt={a.titel}
          datum={nieuwsDatumPill(a.gepubliceerd_op)}
          datumIso={a.gepubliceerd_op}
          titel={a.titel}
          tekst={a.beschrijving}
          to="/nieuws/$slug"
          params={{ slug: a.slug }}
        />
      ))}
      {vullers?.map((v, i) => (
        <NieuwsKaart
          key={`vuller-${i}`}
          img={v.img}
          imgAlt=""
          datum={v.datum}
          titel={v.titel}
          tekst={v.tekst}
          to={v.to}
          lees={v.lees}
        />
      ))}
    </div>
  );
}
